// language=GraphQL
export const ALL_TRAVEL_GUIDES_QUERY = `query Query($withImage: Boolean = false) {
  travelGuides: travelGuides {
    id
    firstName
    lastName
    description
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_GUIDE_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  travelGuide: travelGuide(id: $id) {
    id
    firstName
    lastName
    description
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_GUIDE_MUTATION = `
  mutation Mutation($input: CreateTravelGuideInput, $withImage: Boolean = false) {
    travelGuide: createTravelGuide(input: $input) {
      id
      firstName
      lastName
      description
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_GUIDE_MUTATION = `
  mutation Mutation($input: UpdateTravelGuideInput, $withImage: Boolean = false) {
    travelGuide: updateTravelGuide(input: $input) {
      id
      firstName
      lastName
      description
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_GUIDE_MUTATION = `
  mutation Mutation($input: DeleteTravelGuideInput) {
    deleteTravelGuide(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_GUIDE_MUTATION = `
  mutation Mutation($input: DeleteTravelGuideInput) {
    forceDeleteTravelGuide(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TRAVEL_GUIDES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelTeams: Boolean = false, $withTravels: Boolean = false, $withCmsTravelGuidesBlocks: Boolean = false) {
  groupedDependents: travelGuideDependents(id: $id) {
    travelTeams @include(if: $withTravelTeams) {
      id
      name
    }
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
    cmsTravelGuidesBlocks @include(if: $withCmsTravelGuidesBlocks) {
      id
    }
  }
}`
